// @flow
import * as React from 'react';
import {Caption} from 'sail/Text';
import Group from 'sail/Group';
import Icon from 'sail/Icon';

type HintProps = {|
  children: React.Node,
|};

export const Hint = ({children}: HintProps) => {
  return (
    <Group direction="horizontal" spacing={8} alignItems="center">
      <Icon color="red" icon="cross" />
      <Caption color="red">{children}</Caption>
    </Group>
  );
};
